/* eslint-disable */

export default {
    logEvent(category, action, label, sessionId = '') {
      window.dataLayer.push({
        'appEventCategory': category,
        'appEventAction': action,
        'appEventLabel': label,
        'sessionId': sessionId
      })
      window.dataLayer.push({ 'event': 'appEvent' })
    },
  
    logPage(to, from, sessionId = '') {
      window.dataLayer.push({
        'screenPath': to.path,
        'screenName': to.name,
        'sessionID': sessionId,
        'screenFullPath': window.location.origin,
        'screenReffer': from.path,

      })
      window.dataLayer.push({ 'event': 'appScreenView' })
    }
  }